import { render, staticRenderFns } from "./ShopCategory.vue?vue&type=template&id=fb7160aa&scoped=true&"
import script from "./ShopCategory.vue?vue&type=script&lang=js&"
export * from "./ShopCategory.vue?vue&type=script&lang=js&"
import style0 from "./ShopCategory.vue?vue&type=style&index=0&id=fb7160aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb7160aa",
  null
  
)

export default component.exports